import type { initHoverActions } from 'shared/position/hover-actions'

import { type GifData } from 'api/tenorApi'
import { useEffect, useState } from 'react'

import css from './GifPopover.module.css'
import { useGifSearch } from './hooks/useGifSearch.ts'
import { usePopoverPosition } from './hooks/usePopoverPosition.ts'

export function GifPopover({
	 anchor,
	 hover,
	 onClose,
	 onSelect
}: {
	 anchor?: HTMLElement | null
	 hover?: ReturnType<typeof initHoverActions>
	 onClose: () => void
	 onSelect: (gif: GifData) => void
}) {
	 const [query, setQuery] = useState('')
	 const { gifs, loading, error, searchGifs } = useGifSearch()
	 const { ref, style, popoverListeners } = usePopoverPosition({ anchor, hover, onClose })

	useEffect(() => {
		const timeoutId = setTimeout(() => {
			searchGifs(query)
		}, 300)

		return () => clearTimeout(timeoutId)
	}, [query, searchGifs])

	 return (
	 	<div
	 		{...popoverListeners}
	 		className={css.popover}
	 		ref={ref}
	 		style={style}
	 	>
	 		<input
	 			className={css.search}
	 			onChange={e => setQuery(e.currentTarget.value)}
	 			placeholder='Search for GIFs'
	 			value={query}
	 		/>

	 		{loading && (
	 			<div className={css.loading}>
	 				<p>Loading GIFs...</p>
	 			</div>
	 		)}

	 		{error && (
	 			<div className={css.error}>
	 				<p>{error}</p>
	 			</div>
	 		)}

	 		{!loading && !error && (
	 			<div className={css.grid}>
	 				{gifs.map(gif => (
	 					<button
	 						className={css.item}
	 						key={gif.id}
	 						onClick={() => onSelect(gif)}
	 						type='button'
	 					>
	 						<img alt={gif.title} className={css.preview} src={gif.preview} />
	 					</button>
	 				))}
	 			</div>
	 		)}
		 </div>
	 )
}


